<app-area-search-selector-result icon='nation-wide' display='בכל הארץ' name='בכל הארץ' [state]='state'
    (selected)='select()'
></app-area-search-selector-result>